import { createRouter, createWebHistory } from 'vue-router'
import useAuth from '@/hooks/useAuth';
import appRoutes from "@/hooks/useRoutes";

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/codes',
    meta: { layout: 'main', auth: true },
    component: () => import('@/views/MyCodesController.vue'),
  },
  {
    path: '/login',
    name: 'login',
    meta: { layout: 'empty', auth: false },
    component: () => import('../views/LoginView.vue'),
  },
  {
    path: '/logout',
    name: 'logout',
    meta: { layout: 'empty', auth: false },
    beforeEnter: (to, from, next) => {
      useAuth.logout();
      next('/login');
    }
  },
  {
    path: '/about',
    name: 'about',
    meta: { layout: 'main', auth: true },
    component: () => import('../views/AboutView.vue'),
  },
  {
    path: '/discount',
    name: 'discount',
    meta: { layout: 'main', auth: true },
    component: () => import('../views/PersonalDiscountView.vue'),
  },
  {
    path: '/phones',
    name: 'phones',
    meta: { layout: 'main', auth: true },
    component: () => import('../views/PhoneEditController.vue'),
  },
  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    meta: { layout: 'main', auth: true },
    component: () => import('@/components/NotFoundComponent.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})



// check if user is logged in
const currentUser = useAuth.getCurrentUser();
if (!currentUser && !useAuth.refreshAccessToken()) {
    router.push('/login?message=XM015');
}

if (!currentUser) {
  router.push('/login?message=XM014');
}

const userPerms = useAuth.getCurrentUserData().permissions || [];

appRoutes.init(
  [
    { cat: "menu", order:  1, name: "mm-personal-discount", path: "/discount", view: "views/PersonalDiscountView", perms: [] },
    { cat: "menu", order:  3, name: "mm-codes", path: "/codes", view: "views/MyCodesController", perms: ["corp:code:get"] },
    { cat: "menu", order:  2, name: "mm-deps", path: "/departments", view: "views/DepsView", perms: ["corp:firm:get"] },
    { cat: "menu", order:  4, name: "mm-employees", path: "/employees", view: "views/EmployeesView", perms: ["stat:phones:summary"] },
    { cat: "menu", order:  8, name: "mm-orders", path: "/orders", view: "views/OrdersView", perms: ["stat:orders:ax"] },
    { cat: "menu", order: 10, name: "mm-accounts", path: "/identity", view: "views/ManagerIdentityView", perms: ["mngr:account:get"] },
    { cat: "menu", order: 10, name: "mm-permissions", path: "/permissions", view: "views/ManagerPermissionsView", perms: ["mngr:account:modify"] },
  ],
  userPerms
)

appRoutes.regRoutes(router)
appRoutes.setActiveRoute(window.location.pathname || "/");



// check if user has permissions
router.beforeEach(async (to, from, next) => {
  const currentUser = useAuth.getCurrentUser();
  const requireAuth = to.matched.some((record) => record.meta.auth);

  if (requireAuth && !currentUser) {
    next('/login?message=XM016');
    return;
  }

  next();
});

export default router
